import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { DreItemDTO } from '../../models/dashboard/dre.model';
import { ConfiguracaoEmpresaDashboardDTO } from '../../models/dashboard/configuracao-empresa-dashboard.model';

@Injectable({ providedIn: 'root' })
export class DashboardService {

  constructor(private apiService: ApiService) {}

  // --- DRE (graficos de pizza) ---
  getDadosDre(params: {
    dataInicial: string;
    dataFinal: string;
    filtroMoeda?: string;
  }): Observable<DreItemDTO[]> {
    let query = `dataInicial=${params.dataInicial}&dataFinal=${params.dataFinal}`;
    if (params.filtroMoeda) {
      query += `&filtroMoeda=${params.filtroMoeda}`;
    }
    return this.apiService.read<DreItemDTO[]>(`/dre/listaRecebimentosPorBaixa?${query}`);
  }

  // --- Configuracao da empresa ---
  getConfiguracaoEmpresa(empresaId: number): Observable<ConfiguracaoEmpresaDashboardDTO> {
    return this.apiService.read<ConfiguracaoEmpresaDashboardDTO>(`/configuracaoEmpresa/${empresaId}`);
  }

  // --- Total vendas no mes (para % uso do plano) ---
  getTotalVendasNoMes(): Observable<number> {
    return this.apiService.readText<string>('/nota/valor_de_venda_no_mes').pipe(
      map((res: string) => parseFloat(res) || 0)
    );
  }

  // --- Fatura Eletronica (3 verificacoes) ---
  verificarCertificadoDigital(): Observable<boolean> {
    return this.apiService.read<any>('/configuracaoEmpresa/verifica-certificado-digital-cadastrado').pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  verificarTimbradoEletronico(): Observable<boolean> {
    return this.apiService.read<any>('/timbrado/verificar-timbrado-eletronico-cadastrado').pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  verificarVendaComTimbradoEletronico(): Observable<boolean> {
    return this.apiService.read<any>('/nota/buscar-venda-com-timbrado-eletronico').pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  // --- Primeiros Passos (3 verificacoes) ---
  // Usa size=1 para minimizar dados transferidos (apenas verifica existencia)
  verificarTemProdutos(): Observable<boolean> {
    return this.apiService.read<any>('/item?page=0&size=1').pipe(
      map((res: any) => (res?.content?.length || 0) > 0),
      catchError(() => of(false))
    );
  }

  verificarTemClientes(): Observable<boolean> {
    return this.apiService.read<any>('/pessoas/buscar?page=0&size=1&categoriaCliente=true').pipe(
      map((res: any) => {
        const clientes = (res?.content || []).filter((p: any) => !p.ehClientePadrao);
        return clientes.length > 0;
      }),
      catchError(() => of(false))
    );
  }

  verificarTemVendas(): Observable<boolean> {
    return this.apiService.read<any>('/nota/buscar?page=0&size=1&tipoDeTransacao=VENDA').pipe(
      map((res: any) => (res?.content?.length || 0) > 0),
      catchError(() => of(false))
    );
  }

  // --- Concluir primeiros passos ---
  concluirPrimeirosPassos(): Observable<ConfiguracaoEmpresaDashboardDTO> {
    return this.apiService.patch<ConfiguracaoEmpresaDashboardDTO>(
      '/configuracaoEmpresa/confirmar-conclusao-primeiros-passos',
      {}
    );
  }
}
